import { Box, Grid2, Typography } from "@mui/material";
import CustomCard from "../../../Components/CustomCard";
import {
  businessLoan,
  goldLoan,
  groupLoan,
  pattern3,
  personalLoan,
} from "../../../assets/assets";
import { RedirectLink, ServicesSectionId } from "../../../constants/constants";

const cards = [
  {
    title: "Personal Loan",
    description: `Get quick personal loans with flexible terms and competitive rates.`,
    linkTitle: "Read More",
    icon: personalLoan,
    link: `${RedirectLink.Services}#${ServicesSectionId.PersonalLoan}`,
  },
  {
    title: "Gold Loan",
    description: `Access funds effortlessly with our convenient gold loans and benefit from attractive rates.`,
    linkTitle: "Read More",
    icon: goldLoan,
    link: `${RedirectLink.Services}#${ServicesSectionId.GoldLoan}`,
  },
  {
    title: "Group Loan",
    description: `Empower your community with our affordable group loans.`,
    linkTitle: "Read More",
    icon: groupLoan,
    link: `${RedirectLink.Services}#${ServicesSectionId.GroupLoan}`,
  },
  {
    title: "Business Loan",
    description: `Fuel your growth with our flexible business loans.`,
    linkTitle: "Read More",
    icon: businessLoan,
    link: `${RedirectLink.Services}#${ServicesSectionId.BusinessLoan}`,
  },
];

const WhatWeOffer = () => {
  return (
    <Box
      className="section-divide "
      sx={{
        position: "relative",
      }}
    >
      <img
        src={pattern3}
        width={30}
        style={{ position: "absolute", right: 0, width: "30%", zIndex: "-1" }}
        alt="bg"
      />
      <Box className="container">
        <Box className="section-header-dark align-text-center">
          <Typography variant="h2" className="sec-tittle-color">
            What We Offer
          </Typography>
        </Box>
        <Box className="row padding">
          <Grid2 container spacing={3}>
            {cards.map((item, index) => {
              return (
                <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                  <CustomCard
                    description={item.description}
                    linkTitle={item.linkTitle}
                    title={item.title}
                    descriptionHeight="77px"
                    icon={item.icon}
                    link={item.link}
                  />
                </Grid2>
              );
            })}
          </Grid2>
        </Box>
      </Box>
    </Box>
  );
};

export default WhatWeOffer;
